import { useState, useEffect, useCallback } from "react";

import api from "../../../../api/api";

const useUserAccounts = (activeTab) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUserAccounts = useCallback(async () => {
    if (!activeTab) return;
    if (activeTab === "permission") return;
    if (activeTab === "avatar") return;
    if (activeTab === "admin") return;
    setLoading(true);
    try {
      const queryParam = getQueryParam(activeTab);
      const response = await api.get("/api/firmsetting-page/user-accounts/", {
        params: { q: queryParam },
      });
      setData(response.data);
      setError(null);
    } catch (error) {
      setError(error);
    }
  }, [activeTab]);

  useEffect(() => {
    fetchUserAccounts();
  }, [fetchUserAccounts]);

  return { data, loading, error, refetch: fetchUserAccounts };
};

const getQueryParam = (activeTab) => {
  switch (activeTab) {
    case "all_":
      return "All";
    case "active":
      return "Active";
    case "in-active":
      return "InActive";
    default:
      return "";
  }
};

export default useUserAccounts;
